import React, { useState, useEffect, useRef } from 'react';

const LoadingOverlay = ({ isLoading, isBlocking = true }) => {
    const [elapsedTime, setElapsedTime] = useState(0);
    const timerRef = useRef(null);

    useEffect(() => {
        if (isLoading) {
            const startTime = Date.now();
            timerRef.current = setInterval(() => {
                setElapsedTime(Math.floor((Date.now() - startTime) / 1000)); // Elapsed time in seconds
            }, 1000);
        } else {
            clearInterval(timerRef.current);
            setElapsedTime(0)
        }
        return () => clearInterval(timerRef.current);
    }, [isLoading]);

    return isLoading ? (
        <div
            className="loading-overlay"
            style={isBlocking ? {} : { pointerEvents: 'none', background: 'transparent' }}
        >
            <div className="loading-spinner"></div>
            <div className="loading-text">Loading...</div>
            <div className="loading-timer">
                {elapsedTime > 0 && `(${elapsedTime}s)`}
           </div>
        </div>
    ) : null;
};

export default LoadingOverlay;